import Parser from 'html-react-parser';
import './styles.scss';
import { useMediaQuery } from '@mui/material';
import l from '../../../../lang';
import ButtonCustom from '../../../common/__deprecated__/button-custom';
import { getLanguage, openNewTabAndFocus } from '../../../../utils';
import ButtonLink from '../../../common/button-link';
import { Urls } from '../../../../config/urls';
import { segmentIntegrationsMagentoInstall, segmentIntegrationsMagentoPageLinkDocs } from '../../../../utils/analytics';

const AddToMagento = () => {
  const isTabletMobile = useMediaQuery('(max-width:768px)');

  const getUrl = (lang: string) => {
    switch (lang) {
      case 'es':
        return Urls.docs.magentoIntegration.es;
      case 'en':
        return Urls.docs.magentoIntegration.en;
      default:
        return Urls.docs.magentoIntegration.en;
    }
  };

  return (
    <div className="add-to-magento">
      <div className="add-to-magento__desc">
        <div>{l('paymentIntegration.magento.desc')}</div>
        <p>
          <ButtonLink
            text={l('paymentIntegration.magento.link')}
            onClick={() => {
              segmentIntegrationsMagentoPageLinkDocs();
              openNewTabAndFocus(getUrl(getLanguage()))
            }}
          />
          <span>{Parser(l('paymentIntegration.magento.desc2'))} </span>
        </p>
      </div>
      <div className="add-to-magento__btn">
        <ButtonCustom
          text={l('paymentIntegration.magento.add')}
          variant="contained"
          size={`${isTabletMobile ? 'full-square' : 'square'}`}
          onClick={() => {
            segmentIntegrationsMagentoInstall();
            openNewTabAndFocus(Urls.magentoAddDP)
          }}
        />
      </div>
    </div>
  );
};

export default AddToMagento;
